import {useEffect,} from 'react';


import {useProducts} from '../hooks/useProducts.ts';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {Product} from "../types.ts";
import {TextInputProps} from "@mantine/core";

export const ProductsAutocomplete = (props: FieldProps<Product> & TextInputProps) => {


    const {
        items: records,
        loading,
        fetchRecords
    } = useProducts();


    useEffect(() => {
        fetchRecords();
    }, []);


    return (

        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: Product) => record.name}
            getSelectedOption={(record: Product) => record.name}
            isLoading={loading}
            {...props}
        />

    );
};